<div>
  {{registro.objeto.observacoes}}
  <p ng-if="registro.dataRegistro">Data do Registro: {{registro.dataRegistro | date: 'dd/MM/yyyy'}}</p>
</div>